import DashboardLayout from "@/packages/dashboard/modules/dashboard/views/dashboardLayout";
import Auth from "@/packages/dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "@/packages/dashboard/modules/auth/middleware/ProfileComplete";
import DeferralList from "./components/ExamDeferral.vue";
import Exams from "@/packages/exams/view/exam";
import ExamDeferralCard from "@/packages/exams/modules/Deferrals/components/ExamDeferralCard";

export default [
  {
    path: "/exams",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "deferrals",
            name: "Deferrals",
            component: DeferralList,
            middleware: [Auth, ProfileComplete],
          },
          {
            path: "deferrals/card/:code?",
            name: "DeferralCard",
            component: ExamDeferralCard,
            middleware: [Auth, ProfileComplete],
          },
        ],
      },
    ],
  },
];
